import React, { useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";

import PresetModal from "components/PresetModal";
import GenreBadges from "components/GenreBadges";
import CartPlayButtons from "components/CartPlayButtons";
import { addCartItemRequest, cartItemIds, addPreview } from "../actions";

const PresetRow = ({ dispatch, cart_items_ids, preset_pack }) => {
  const [modalShow, setModalShow] = useState(false);
  
  const addPackToCart = (cart_item) => {
    dispatch(addCartItemRequest(cart_item.id));
  };
  
  const playPreview = () => {
    dispatch(addPreview(preset_pack));
  };
  
  const inCart = cart_items_ids.includes(preset_pack.id);

  return (
    <>
      <tr>
        <td className="d-none d-sm-table-cell">
          <img 
            src={preset_pack.images.thumb}
            width="75"
            style={{ cursor: 'pointer' }}
            onClick={() => setModalShow(true)}
            alt={preset_pack.name}
            className="preset-thumb"
          />
        </td>
        <td className="d-none d-sm-table-cell">
          <h5
            style={{ cursor: 'pointer' }}
            onClick={() => setModalShow(true)}
          >
            {preset_pack.name}
          </h5>
        </td>
        <td className="d-none d-sm-table-cell" style={{ width: "16.66%" }}>
          <GenreBadges genres={preset_pack.genres} />
        </td>
        <td className="d-none d-sm-table-cell">
          <a href={`/preset_packs/manufacturers/${preset_pack.manufacturer_slug}`}>
            {preset_pack.manufacturer_name}
          </a>
        </td>
        <td>
          {/* Mobile view */}
          <div className="d-block d-sm-none">
            <Row className="align-items-center">
              <Col xs={5}>
                <img 
                  src={preset_pack.images.thumb} 
                  className="mobile-preset-image" 
                  onClick={() => setModalShow(true)}
                  alt={preset_pack.name}
                  style={{ cursor: 'pointer' }}
                />
              </Col>
              <Col xs={7}>
                <strong 
                  style={{ cursor: 'pointer' }}
                  onClick={() => setModalShow(true)}
                >
                  {preset_pack.name}
                </strong>
                <br />
                by {preset_pack.manufacturer_name}
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-center align-items-center preset-table-actions mt-2">
            <CartPlayButtons 
              addToCart={addPackToCart} 
              preset_pack={preset_pack} 
              inCart={inCart} 
            />
          </div>
        </td>
      </tr>

      <PresetModal
        preset_pack={preset_pack}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

const mapStateToProps = state => ({
  cart_items_ids: cartItemIds(state.cart_items)
});

export default connect(mapStateToProps)(PresetRow);
